// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vue-multiselect.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("0888e689", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/vue-multiselect/dist/vue-multiselect.min.css
// module id = 41
// module chunks = 27